{
  "action": "Effective Access",
  "title": "Effective access",
  "loading": "Resolving access…",
  "status": {
    "active": "Active",
    "deactivated": "Deactivated"
  },
  "super": {
    "super-admin": "Super Admin",
    "super-user": "Super User"
  },
  "roleAtPlace": "{{place}} {{role}}",
  "superRung": {
    "action": "Super rung",
    "column": "Super",
    "title": "Super rung for {{displayName}}",
    "description": "A super rung reaches every organisation and location.",
    "choices": {
      "none": "None",
      "super-user": "Super User",
      "super-admin": "Super Admin"
    },
    "hints": {
      "none": "Access comes from their assignments only.",
      "super-user": "Reaches every organisation and location; Administration is read-only.",
      "super-admin": "Reaches every organisation and location and can change Administration, including other people's super rung."
    },
    "save": "Save",
    "cancel": "Cancel",
    "forbidden": "Only a Super Admin can change a super rung, and never their own.",
    "notFound": "This user no longer exists."
  },
  "userAssignment": {
    "addTitle": "Add a new user",
    "updateTitle": "Update assignments of {{displayName}}",
    "email": "Email (this will be the login username)",
    "firstName": "First name",
    "lastName": "Last name",
    "submit": "Submit",
    "current": "Current assignments",
    "none": "No assignments yet.",
    "held": "{{place}}: {{capability}}",
    "replaceHint": "Saving replaces their assignment at the chosen location only. Their other locations are kept.",
    "forbidden": "You can't assign people at this location.",
    "notFound": "This user no longer exists.",
    "refused": "The assignment could not be saved."
  },
  "location": {
    "label": "Location",
    "placeholder": "Choose a location",
    "nothingFound": "No matching location",
    "assignment": "assignment",
    "anyLocation": "reachable as a super"
  },
  "capability": {
    "user": "user",
    "admin": "admin",
    "super": "super"
  },
  "persona": {
    "producer": "producer",
    "agent": "agent"
  },
  "rung": {
    "any": "any",
    "admin": "admin",
    "super": "super",
    "super-admin": "super-admin"
  },
  "summary": {
    "defaultRole": "Default role",
    "noRole": "None",
    "lens": "Lens",
    "lensAdmin": "Admin view",
    "lensSupplier": "Supplier view",
    "canToggle": "can toggle",
    "noToggle": "no toggle",
    "noSupplierView": "no supplier view",
    "present": "Present here",
    "presentValue": "{{nav}} nav items · {{tab}} tabs"
  },
  "roles": {
    "title": "Roles",
    "empty": "This person holds nothing at this location.",
    "capability": "Capability",
    "persona": "Persona",
    "via": "{{role}} · shared from {{place}}"
  },
  "tree": {
    "title": "Features",
    "showNoGrant": "Show features with no grant here",
    "empty": "No features to show",
    "openInAccess": "Open in Access"
  },
  "chips": {
    "granted": "{{source}} · {{rung}}",
    "grantedNoRung": "{{source}}",
    "location": "location",
    "global": "global",
    "share": "share",
    "pilot": "pilot",
    "implied": "implied by its tabs",
    "otherLens": "other lens",
    "rung": "needs {{rung}}",
    "config": "config missing",
    "parent": "no parent",
    "no-row": "no row"
  },
  "scope": {
    "title": "Row scope",
    "dataset": "Dataset",
    "column": "Column",
    "values": "Values",
    "unrestricted": "unrestricted",
    "noColumn": "—",
    "empty": "empty — every request here is refused"
  },
  "recentChanges": {
    "title": "Recent changes",
    "empty": "No changes recorded for this person yet"
  },
  "errors": {
    "forbidden": "Only a Super Admin or Super User can read someone else's effective access.",
    "notFound": "No user with this id.",
    "generic": "Could not resolve access for this person."
  },
  "level": {
    "nav": "nav",
    "tab": "tab",
    "section": "section",
    "action": "action"
  },
  "features": {
    "administration": "Administration",
    "administration-organisations": "Organisations",
    "administration-org-locations": "Org Locations",
    "administration-users": "Users",
    "administration-roles": "Roles",
    "administration-permissions": "Permissions",
    "administration-action-log": "Action Log",
    "administration-audit-log": "Audit",
    "administration-organisations-edit": "Edit organisations",
    "administration-org-locations-edit": "Edit org locations",
    "administration-users-edit": "Edit users",
    "administration-roles-edit": "Edit roles",
    "administration-permissions-edit": "Edit permissions",
    "management": "Management",
    "management-users": "Users",
    "management-gmp-pics": "Pics",
    "management-audit": "Recent changes",
    "management-users-edit": "Edit users",
    "management-users-assign-scope": "Assign user scope",
    "management-gmp-pics-edit": "Assign PICs",
    "meq-camera": "MEQ Camera",
    "camera-user-analytics": "User Analytics",
    "camera-grader-scorecard": "Grader Scorecard",
    "camera-mb-gateway-movement": "MB Gateway Movement",
    "camera-beef-analytics": "Beef Analytics",
    "camera-aus-meat-omm": "AUS-MEAT OMM",
    "camera-image-comparison": "Image Comparison",
    "camera-wagyu-demo": "Wagyu",
    "camera-dataset-tagging": "Dataset tagging",
    "camera-dataset-tagging-tag": "Tag images",
    "camera-aus-meat-omm-settings-edit": "Edit AUS-MEAT OMM settings",
    "data-analysis-overview": "MEQ Data Analytics",
    "dao-beef-overview": "Beef Overview",
    "dao-producers": "Producers",
    "dao-comparisons": "Comparisons",
    "dao-benchmarking": "Benchmarking",
    "dao-plant-comparison": "Plant Comparison",
    "dao-live-to-camera": "Live to Camera Dashboard",
    "dao-merged-animal-data": "Merged animal data",
    "dao-consignments-edit": "Edit consignment names",
    "gmp-lamb-data-analysis": "GMP Lamb Data Analysis",
    "gmp-dashboard": "Dashboard",
    "gmp-awards": "Awards",
    "gmp-comparison": "Comparison",
    "gmp-animal-health": "Animal Health",
    "gmp-producer-dashboard": "Producer Dashboard",
    "gmp-all-clients": "All clients",
    "gmp-lot-names-edit": "Edit lot descriptions",
    "gmp-awards-config-edit": "Edit awards configuration",
    "gmp-lamb-bookings": "GMP Lamb Booking",
    "gmp-bookings-bookings": "Bookings",
    "gmp-bookings-weekly-overview": "Weekly Overview",
    "gmp-bookings-admin": "Admin",
    "gmp-bookings-producer": "Producer",
    "gmp-bookings-bookings-edit": "Edit bookings",
    "gmp-bookings-grids-edit": "Edit grids",
    "gmp-bookings-supply-agreements-complete": "Complete supply agreements",
    "gmp-upload": "GMP Upload",
    "gmp-upload-submit": "Submit an upload",
    "meq-live": "MEQ Live",
    "meq-live-admin": "MEQ Live Admin",
    "meq-live-genetics": "MEQ Live Genetics",
    "genetics-harmony-insights": "Harmony Insights",
    "meq-probe": "MEQ Probe",
    "probe-lamb-summary": "Summary of Lamb Scans",
    "probe-beef-summary": "Summary of Beef Scans",
    "probe-shift-scores": "Shift Scores",
    "usda-audit": "USDA Audit",
    "usda-audit-review-edit": "Edit audit reviews",
    "usda-audit-feedback": "USDA Audit Feedback",
    "usda-image-calibration": "USDA Image Calibration",
    "record-labelling-admin": "Record Labelling",
    "record-labelling-projects-edit": "Edit labelling projects",
    "my-assignments": "My Assignments",
    "record-labelling-labels-submit": "Submit labels"
  },
  "legend": {
    "show": "What do these mean?",
    "hide": "Hide the explanation",
    "rungPlaceholder": "rung",
    "location": "A grant row written at this location. The rung says who it reaches: any is everyone with a role here, admin is admins, super is the super roles.",
    "global": "A grant held in code that applies at every location unless the location writes its own row. Actions, which are writes, are granted this way.",
    "share": "This location shares the feature with another place, and the person holds it there, so they hold it here too. The shared role never opens in the app.",
    "pilot": "This person is named on the row, so they hold the feature whatever their rung.",
    "implied": "The nav item has no row of its own. It appears because one of its tabs is granted.",
    "rung": "A row exists, but it reaches a higher rung than this role holds.",
    "config": "A row exists, but the location lacks the settings the feature needs, so it stays hidden until they are added.",
    "parent": "This role meets the feature's own row, but the feature above it is not present, so it cannot appear.",
    "no-row": "Nothing grants this feature at this location and no global grant covers it. Nobody sees it here, the super roles included.",
    "otherLens": "Present, but it renders in the other view, admin or supplier, from the one this person opens in."
  },
  "refusal": {
    "feature-missing": "This isn't enabled for your current location.",
    "scope-empty": "No farmers are assigned to you here.",
    "scope-violation": "That request includes records outside what you can see.",
    "action-forbidden": "You don't have permission to do this here.",
    "export-limit": "That range is longer than this export allows.",
    "org-unmapped": "This organisation isn't recognised.",
    "place-unnamed": "No organisation named."
  },
  "gate": {
    "error": "We couldn't load what you can see at this location.",
    "retry": "Try again"
  },
  "emptyScope": {
    "title": "Nothing is assigned to you here yet",
    "body": "No farmers, suppliers or PICs are assigned to you at this location, so there is no data to show. Ask your administrator to assign them."
  },
  "grants": {
    "tab": "Access",
    "views": {
      "feature": "By feature",
      "location": "By location"
    },
    "features": {
      "intro": "Pick a feature to see its grant at every location. A location's own row overrides the global default.",
      "pick": "Feature",
      "placeholder": "Pick a feature",
      "nothingFound": "No feature matches",
      "global": "Global default:",
      "noGlobal": "none, only locations with a row grant it",
      "rowsOnly": "Only locations with their own row",
      "noRows": "No location writes its own row for this feature.",
      "openLocation": "Open this location in By location"
    },
    "locations": {
      "intro": "Pick a location to see every feature's grant there. Rows from the global default apply until the location writes its own.",
      "pick": "Location",
      "placeholder": "Pick a location",
      "nothingFound": "No location matches",
      "rowsOnly": "Only features with a row here",
      "noRows": "This location writes no rows of its own."
    },
    "columns": {
      "location": "Location",
      "feature": "Feature",
      "source": "Source",
      "rungAndPilots": "Rung and pilots",
      "rungAndPilotsHelp": {
        "title": "What the rung and pilots mean",
        "none": "Nobody sees the feature at this location, the super roles included.",
        "default": "No row here, so the global grant held in code applies.",
        "super-admin": "Only super-admins, not super-users, plus the row's pilots.",
        "super": "Only the MEQ super roles.",
        "admin": "Admins at this location, plus the super roles.",
        "any": "Everyone with a role at this location.",
        "pilots": "Named people who get the feature even though the rung doesn't reach them, for trying it out before widening. Anyone the rung already covers is removed from the list automatically."
      }
    },
    "source": {
      "default": "Global default",
      "override": "Override",
      "location": "Location row"
    },
    "rung": {
      "none": "None",
      "default": "Default",
      "defaultOf": "Default · {{rung}}",
      "super-admin": "Super admin",
      "super": "Super",
      "admin": "Admin",
      "any": "Any"
    },
    "pinned": "Super-admin only, held in code",
    "pilots": {
      "label": "Pilots",
      "placeholder": "No pilots",
      "nothingFound": "Nobody holds an assignment here"
    },
    "stripped": {
      "title": "Pilots removed",
      "body_one": "{{names}} already reaches the feature through the rung, so they were not kept as a pilot.",
      "body_other": "{{names}} already reach the feature through the rung, so they were not kept as pilots."
    },
    "configSuppressed": {
      "withPath": "Granted, unconfigured: set {{path}}",
      "noPath": "Granted, unconfigured"
    },
    "shares": {
      "title": "Shares",
      "intro": "A share lends this feature at one location to whoever holds it at another, along with what sits under it there. They hold it through a separate role that never opens in the app, so nothing new appears in their navigation.",
      "none": "No location shares this feature.",
      "row": "{{owner}} shared with {{audience}}",
      "owner": "Location",
      "audience": "Shared with",
      "add": "Add share",
      "remove": "Remove share",
      "badge": "Shared with {{places}}"
    },
    "loading": "Loading grants…"
  }
}
